import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/material/migration/migrating-from-deprecated-apis/migrating-from-deprecated-apis.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
